import { uploadFile } from 'src/shared/helpers';
import { mergeModelSideAction, uploadSideImageEndAction, uploadSideImageStartAction } from '../actions';
import { useProductConfigurationState } from '../stateProvider';
import { ModelSide, fitSideToImage } from './modelSide';

export const useModelSideManager = () => {
    const { state, dispatch } = useProductConfigurationState();

    return {
        changeImage: async (modelSide: ModelSide, file: File, adaptArea: boolean = false, scaleSideImage?: boolean) => {
            try {
                dispatch(uploadSideImageStartAction(modelSide));

                const url = typeof scaleSideImage === 'boolean' ? await uploadFile(file, scaleSideImage) : await uploadFile(file);

                const image = await new Promise<HTMLImageElement>((resolve, reject) => {
                    const img = new Image();
                    img.onload = () => resolve(img);
                    img.onerror = reject;
                    img.src = url;
                });

                dispatch(
                    mergeModelSideAction(modelSide, {
                        ...(adaptArea ? fitSideToImage(modelSide, image) : modelSide),
                        imageUrl: url
                    })
                );

                dispatch(uploadSideImageEndAction(modelSide));
            } catch (ex) {
                console.error(ex);
                dispatch(uploadSideImageEndAction(modelSide));
            }
        },
        getUploadStatus: (modelSide: ModelSide) => {
            const upload = state.sideImageUploads.find((x) => x.modelSide == modelSide);

            return {
                uploading: !!upload,
                progress: upload?.progress
            };
        }
    };
};
